import React from 'react';

const REPO_URL = 'https://github.com/dinotechltd/dino-backoffice';

const commitRef = process.env.GATSBY_COMMIT_REF;
const buildTime = process.env.GATSBY_BUILD_TIME;

export const AppVersion = () => (
  <div className="text-xs text-gray-500 dark:text-gray-400">
    Version:{' '}
    {commitRef ? (
      <a
        href={`${REPO_URL}/commit/${commitRef}`}
        target="_blank"
        rel="noreferrer"
        className="font-mono underline"
        title={commitRef}
      >
        {commitRef.slice(0, 7)}
      </a>
    ) : (
      <span className="font-mono">local</span>
    )}
    {buildTime && <> · built {new Date(buildTime).toLocaleString()}</>}
  </div>
);
